export enum EUpdateCardStatus {
    "positive",
    "negative",
    "default",
}
